<section class="fancy-h3" *ngIf="title || lead">
  <div class="container">
    <h3 *ngIf="title">{{ title }}</h3>
    <p *ngIf="lead" [innerHTML]="lead"></p>
  </div>
</section>
